import { FC } from 'react';

type PromiseBadgeProps = {
  /** Resolved URL of the Sanity promise icon (the SVG seal). */
  iconUrl?: string;
  headline: string;
  termsLine?: string;
  /**
   * 'dark' for the navy verdict screens (default), 'light' for the paywall's
   * light surface. Controls only the text colours — the blue surface tint and
   * primary border are shared across both.
   */
  variant?: 'dark' | 'light';
};

const VARIANT_TEXT = {
  dark: {
    headline: 'text-white',
    terms: 'text-neutral-300'
  },
  light: {
    headline: 'text-neutral-800',
    terms: 'text-neutral-500'
  }
} as const;

/**
 * The Mini-League Promise badge. Appears only at the verdict/paywall
 * handoff — never at the email gate (spec 6.7).
 */
const PromiseBadge: FC<PromiseBadgeProps> = ({
  iconUrl,
  headline,
  termsLine,
  variant = 'dark'
}) => {
  const text = VARIANT_TEXT[variant];

  return (
    <div className="flex items-center gap-2 rounded-xl border-2 border-primary-600 bg-[#1FD0FF]/5 px-2 py-4">
      {iconUrl && (
        <img
          src={iconUrl}
          alt=""
          aria-hidden="true"
          width={48}
          height={48}
          className="h-12 w-12 shrink-0"
        />
      )}
      <div className="min-w-0">
        <p
          className={`font-heading text-base font-bold leading-snug ${text.headline}`}
        >
          {headline}
        </p>
        {termsLine && (
          <p
            className={`mt-1 whitespace-nowrap font-body text-xs ${text.terms}`}
          >
            {termsLine}
          </p>
        )}
      </div>
    </div>
  );
};

export default PromiseBadge;
